import React from 'react';
import { isSameMonth, isToday, format } from 'date-fns';
import styles from '../EventCalendar.module.scss';
import Text from '../../text/Text';

const EventIndicator = React.memo(({ color, text }) => (
  <div className={styles.eventDate}>
    <span
      className={styles.eventIndicator}
      style={{ backgroundColor: color ?? 'red' }}
    ></span>
    <Text
      title={text}
      className={styles.text}
      variant="text-regular-16-black"
    />
  </div>
));
EventIndicator.displayName = 'EventIndicator';
const Footer = ({ events }) => {
  const uniqueEvents = events.filter(
    (e, index, self) =>
      index === self.findIndex((t) => t.colorCode === e.colorCode)
  );

  return uniqueEvents.map((event, index) => (
    <div key={index} className={styles.eventDate}>
      <div
        className={styles.eventIndicator}
        style={{ backgroundColor: event.colorCode ?? 'red' }}
      ></div>

      <Text
        title={event.calendarText}
        className={styles.text}
        variant="text-regular-16-black"
      />
    </div>
  ));
};
export { EventIndicator, Footer };
